import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useMemo,
} from "react";

const LikedProductsContext = createContext();

export const useLikedProducts = () => useContext(LikedProductsContext);

export const LikedProductsProvider = ({ children }) => {
  const [likedProducts, setLikedProducts] = useState(() => {
    const storedLikes = localStorage.getItem("likedProducts");
    const parsedLikes = storedLikes ? JSON.parse(storedLikes) : [];
    return parsedLikes.filter((product) => product.upc !== "");
  });

  useEffect(() => {
    if (likedProducts.length > 0) {
      localStorage.setItem("likedProducts", JSON.stringify(likedProducts));
    } else {
      localStorage.removeItem("likedProducts");
    }
  }, [likedProducts]);

  const addLikedProduct = (product) => {
    if (product.upc !== "") {
      setLikedProducts((prev) => [...prev, product]);
    }
  };

  const removeLikedProduct = (productId) => {
    setLikedProducts((prev) =>
      prev.filter((product) => product.upc !== productId)
    );
  };

  const isProductLiked = (productId) =>
    likedProducts.some((product) => product.upc === productId);

  const displayLikedProducts = () => {
    return likedProducts;
  };

  const contextValue = useMemo(
    () => ({
      likedProducts,
      addLikedProduct,
      removeLikedProduct,
      isProductLiked,
      displayLikedProducts,
    }),
    [likedProducts]
  );

  return (
    <LikedProductsContext.Provider value={contextValue}>
      {children}
    </LikedProductsContext.Provider>
  );
};
